import React, { useMemo } from 'react';
import { RouteComponentProps, Switch } from 'react-router-dom';

import MagicLinkInit from './MagicLinkInit';
import MagicLinkStatus from './MagicLinkStatus';
import MagicLinkTimedOut from './MagicLinkTimedOut';
import MagicLinkOtpVerification from './MagicLinkOtp';
import InvalidPhone from './InvalidPhone';
import Error from './Error';

import {
  EntryTokenProvider,
  EntryRoute,
  NonEntryRoute,
} from 'routes/EntryProtectedRoute';
import WrappedRoute from 'routes/WrappedRoute';

type PropTypes = RouteComponentProps;

const MagicLinkVerification: React.FC<PropTypes> = props => {
  const { match } = props;
  const parentPath = useMemo(() => {
    // Ensure parent path does not have trailing slash
    return match.path.replace(/\/$/, '');
  }, [match]);

  return (
    <EntryTokenProvider>
      <Switch>
        <WrappedRoute
          path={match.path}
          exact
          wrappers={[EntryRoute]}
          render={props => <MagicLinkInit parentPath={parentPath} {...props} />}
        />
        <WrappedRoute
          path={`${parentPath}/magic-link-status`}
          exact
          wrappers={[NonEntryRoute]}
          render={props => {
            return <MagicLinkStatus parentPath={parentPath} {...props} />;
          }}
        />
        <WrappedRoute
          path={`${parentPath}/magic-link-otp-verification`}
          exact
          wrappers={[NonEntryRoute]}
          render={props => (
            <MagicLinkOtpVerification parentPath={parentPath} {...props} />
          )}
        />
        <WrappedRoute
          path={`${parentPath}/magic-link-timed-out`}
          exact
          wrappers={[NonEntryRoute]}
          render={props => (
            <MagicLinkTimedOut parentPath={parentPath} {...props} />
          )}
        />
        <WrappedRoute
          path={`${parentPath}/magic-link-invalid-phone`}
          exact
          wrappers={[NonEntryRoute]}
          render={props => <InvalidPhone parentPath={parentPath} {...props} />}
        />
        <WrappedRoute
          path={`${parentPath}/magic-link-error`}
          exact
          wrappers={[NonEntryRoute]}
          component={Error}
        />
      </Switch>
    </EntryTokenProvider>
  );
};

export default MagicLinkVerification;
